import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 41 41"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M31.444 33.618q-4.4.038-8.728-2.229-4.329-2.266-7.792-5.95a31.2 31.2 0 0 1-5.61-8.327Q7.166 12.47 7.167 7.828q0-.59.051-1.29.053-.7.19-1.252h9.213l1.766 8.216-4.779 4.605q1.731 2.91 3.74 5.03a20.7 20.7 0 0 0 4.503 3.592l4.71-5.048 7.272 1.88v9.836q-.519.075-1.195.148-.675.073-1.194.073"
    }, null, -1)
  ])))
}
export default { render: render }